module.exports = __webpack_public_path__ + "img/2-4.99dc6e30.gif";